import { useModal } from '@shared/model/useModal';

export const useCancelOrderModal = () => useModal('cancel-order')